/**
 *
 * aegis helper
 *
 * 约定
 *
 * uin 为 openId
 * ext1 为 tinyId,
 * ext2 为 av_room_id, rtc 房间号
 * ext3 为 meeting_code， 会议号
 */

export const setAegisUin = (openId: string) => {
  window.aegis?.setConfig({
    uin: openId,
  });
};

/**
 *
 * @param param
 * {
 *   ext1: tinyId,
 *   ext2: av_room_id,
 *   ext3: meeting_code
 * }
 */
export const setAegisExt = ({ ext1 = '', ext2 = '', ext3 = '' }) => {
  window.aegis?.setConfig({
    ext1,
    ext2,
    ext3,
  });
};

export const reportUserLoginSuceess = () => {
  window.aegis?.reportEvent({
    name: '账号登录成功',
  });
};

export const reportUserLoginFail = () => {
  window.aegis?.reportEvent({
    name: '账号登录失败',
  });
};

export const reportXMPPConnectSuceess = () => {
  window.aegis?.reportEvent({
    name: 'XMPP连接成功',
  });
};

export const reportXmppConnectFail = (e: any) => {
  window.aegis?.reportEvent({
    name: 'XMPP连接失败',
    ext1: e,
  });
};

export const reportXMPPJoinSuccess = () => {
  window.aegis?.reportEvent({
    name: 'XMPP进会成功',
  });
};

export const reportXMPPJoinFail = (e: any) => {
  window.aegis?.reportEvent({
    name: 'XMPP进会失败',
    ext1: e,
  });
};

export const reportRTCEnterRoomSuccess = () => {
  window.aegis?.reportEvent({
    name: 'RTC进房成功',
  });
};

export const reportRTCEnterRoomFail = (e: any) => {
  window.aegis?.reportEvent({
    name: 'RTC进房失败',
    ext1: e,
  });
};

export const reportUserEnter = (isCreator: boolean) => {
  window.aegis?.reportEvent({
    name: '普通用户入会',
    ext3: isCreator ? '创建者' : '非创建者',
  });
};

export const reportCreatorEnter = () => {
  window.aegis?.reportEvent({
    name: '创建者入会',
  });
};

export const reportGuestEnter = () => {
  window.aegis?.reportEvent({
    name: '游客入会',
  });
};
/**
 * 计时开始：进房总耗时
 */
export const reportTimeStartJoinMeetingTotal = () => {
  window.aegis?.time('JoinMeetingTotal');
};

/**
 * 计时结束：进房总耗时
 */
export const reportTimeEndJoinMeetingTotal = () => {
  window.aegis?.timeEnd('JoinMeetingTotal');
};

/**
 * 计时开始：XMPP 建联耗时
 */
export const reportTimeStartXMPPConnect = () => {
  window.aegis?.time('XMPPConnect');
};

/**
 * 计时结束：XMPP 建联耗时
 */
export const reportTimeEndXMPPConnect = () => {
  window.aegis?.timeEnd('XMPPConnect');
};

/**
 * 计时开始：XMPP 进房耗时
 */
export const reportTimeStartXMPPJoinMeeting = () => {
  window.aegis?.time('XMPPJoinMeeting');
};

/**
 * 计时结束：XMPP 进房耗时
 */
export const reportTimeEndXMPPJoinMeeting = () => {
  window.aegis?.timeEnd('XMPPJoinMeeting');
};

/**
 * 计时开始：TRTC 进房耗时
 */
export const reportTimeStartTRTCEnterRoom = () => {
  window.aegis?.time('TRTCEnterRoom');
};

/**
 * 计时结束：TRTC 进房耗时
 */
export const reportTimeEndTRTCEnterRoom = () => {
  window.aegis?.timeEnd('TRTCEnterRoom');
};

/**
 * 计时开始：用户点击开麦到麦克风状态发生改变
 */
export const reportTimeStartUnmuteMicro = () => {
  window.aegis?.time('UnmuteMicro');
};

/**
 * 计时结束：用户点击开麦到麦克风状态发生改变
 */
export const reportTimeEndUnmuteMicro = () => {
  window.aegis?.timeEnd('UnmuteMicro');
};

/**
 * 计时开始：开摄像头到摄像头状态发生变化
 */
export const reportTimeStartUnmuteCamera = () => {
  window.aegis?.time('UnmuteCamera');
};

/**
 * 计时结束：开摄像头到摄像头状态发生变化
 */
export const reportTimeEndUnmuteCamera = () => {
  window.aegis?.timeEnd('UnmuteCamera');
};
